import React from 'react';
import { useSelector } from 'react-redux';
import CardFormat from '../enrolments/cardFormat';
import CardFormats from '../enrolments/cardFormats';
import EmailAccount from './EmailAccount';
import MobileAccount from './MobileAccount';
import MobileAccounts from './MobileAccounts';
import Holiday from './holiday';
import Holidays from './holidays';
import Message from './message';
import Messages from './messages';
import Site from './site';
import Sites from './sites';
import SecurityPolicies from "./SecurityPolicies";
import SecurityPolicy from "./SecurityPolicy";
import Events from './events';

function getPageForRoute(key) {
    const selected = {
        'account': <MobileAccount />,
        'accounts': <MobileAccounts />,
        'card-format': <CardFormat />,
        'card-formats': <CardFormats />,        
        'holidays': <Holidays />,
        'holiday': <Holiday />, 
        'messages': <Messages />,
        'message': <Message />,
        'site': <Site />,
        'sites': <Sites />,
        'account-setup': <EmailAccount/>,
        'security-policies':<SecurityPolicies/>,
        'security-policy':<SecurityPolicy/>,
        'events': <Events />
    }[key];

    if (selected) { return selected; }
    return <div style={{ marginLeft: "20px", marginTop: "20px" }}>This page is not available yet</div>
}

function getKeyFromPath(path) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const ConfigurationIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);
    return getPageForRoute(getKeyFromPath(page));
};

export default ConfigurationIndex;
